import { useQuery } from '@tanstack/react-query';

import { getAllClaimCampaigns } from '~/services/LuxLoyaltyService';

import { claimsQueryKeys } from './claimsQueryKeys';

export function useGetClaimCampaigns() {
  return useQuery({
    queryKey: claimsQueryKeys.campaigns(),
    queryFn: getAllClaimCampaigns,
    select: (data) => data.result.campaigns.filter((c) => c.status === 'ACTIVE' && c.type === 'NORMAL'),
  });
}
